import { useState } from 'react';

import { Gate } from '../../../global/contexts/auth/auth';
import { useAnimalStats } from '../../stats/contexts/stats';
import StatsView, { StatsFilters, OffspringPanel } from '../../stats/layouts/entity-stats';
import SgProductivePanel from '../../sg/layouts/productive-panel';

const todayStr = () => new Date().toLocaleDateString('en-CA');
const yearStart = () => `${new Date().getFullYear()}-01-01`;

// Estadísticas de una DONANTE (admin-stats.md): funnel personal anclado en sus
// aspiraciones (OPU). Filtro por rango de fecha de la sesión OPU.
export default function AnimalStats({ animalId }) {
    const [range, setRange] = useState({ from: yearStart(), to: todayStr() });
    const { data, isLoading, isFetching, error } = useAnimalStats(animalId, range);
    const name = data?.entity?.name || data?.entity?.number || `#${animalId}`;

    return (
        <StatsView
            data={data} isLoading={isLoading} isFetching={isFetching} error={error}
            title={`Donante · ${name}`}
            subtitle="Funnel reproductivo de la donante (sus aspiraciones)."
            backTo={`/admin/animals/${animalId}`} backLabel="Volver al animal"
            filters={<StatsFilters range={range} onRange={(p) => setRange((r) => ({ ...r, ...p }))} busy={isFetching} />}
        >
            <OffspringPanel title="Crías (genealogía)" data={data?.offspring} />
            <Gate domain="sg" action="read">
                <SgProductivePanel animalId={animalId} />
            </Gate>
        </StatsView>
    );
}
